export default "__VITE_ASSET__CbXnaOnb__"